export default __webpack_public_path__ + "static/media/tools-bj-top.9501c4a6.png";